const Spinner = () => {
  return (
    <div className="flex justify-center items-center flex-col">
      <div
        className="loader ease-linear rounded-full border-8 border-t-8 border-gray-200 h-12 w-12 animate-spin mt-5"
        style={{ borderTopColor: 'rgba(16, 185, 129,1)' }}
      ></div>
    </div>
  );
};

export default Spinner;
